import React from 'react';
import styled from 'styled-components';
import { Breakpoints, Grid } from '../../app/StyleGuide';

const Container = styled.div`
  flex-shrink: 0;
  background: white;
  padding: ${Grid._4};
  box-shadow: inset 0 1px rgba(0, 0, 0, 0.1);
  width: 100%;
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  z-index: 101;
  div {
    margin: 0 0 8px;
  }

  @media screen and (min-width: ${Breakpoints.screen_sm}) {
    flex-direction: row;
    div {
      margin: 0 8px;
    }
  }
`;

const CompleteStepButtonContainer = ({ children }: { children: React.ReactNode }) => {
  return <Container>{children}</Container>;
};

export default CompleteStepButtonContainer;
